<template>
  <a-row
    type="flex"
    justify="start"
    align="middle"
    class="fast-comment-txarea"
  >
    <div class="popover-card" id="popover-card" v-if="visible">
      <div class="pointer" />
      <a-spin :spinning="spinning">
        <div class="fast-tooltip-wrap">
          <p class="title">
            <a-button
              type="link"
              icon="plus-circle"
              :disabled="diyComments.length === 50"
              @click="addDiyComment"
            >
              添加自定义评语
            </a-button>
            <span class="num">
              {{ diyComments.length }}/50条
            </span>
          </p>
          <div class="comment-wrap">
            <ul class="diy-comment">
              <li
                class="item-comment"
                v-for="(diyComment, diyIndex) in diyComments"
                @click="selectedDiyComment(diyIndex)"
                :key="diyIndex"
              >
                <div class="str">
                  <div v-if="!diyComment.edit">
                    <a-tooltip
                      :overlay-style="{width: '240px'}"
                      :get-popup-container="getPopupContainer"
                      v-if="getBool(diyComment.name, 'diy')"
                    >
                      <template slot="title">
                        {{ diyComment.name }}
                      </template>
                      <p>
                        <span class="item-comment-name">{{ diyComment.name }}</span>
                      </p>
                    </a-tooltip>
                    <p v-else>
                      <span class="item-comment-name">{{ diyComment.name }}</span>
                    </p>
                  </div>
                  <div v-else class="item-comment-textarea-wrap">
                    <a-textarea
                      class="item-textarea"
                      placeholder="请输入评语"
                      :max-length="maxRemarkLength"
                      :auto-size="{ minRows: 1, maxRows: 3 }"
                      v-model="diyComment.name"
                      @change="diyTextareaChange(diyIndex)"
                    />
                    <span class="item-textarea-num" v-if="diyComment.showNum">
                      {{ diyComment.name.length }}/200
                    </span>
                  </div>
                </div>
                <div class="btn-group">
                  <div class="btn-edit" v-if="diyComment.edit">
                    <a-button :disabled="!diyComment.name" @click.stop="save(diyIndex)" type="link">
                      保存
                    </a-button>
                    <a-button type="link" @click.stop="cancelDiyComment(diyIndex)">
                      取消
                    </a-button>
                  </div>
                  <div class="btn-show" v-else>
                    <a-button type="link" @click.stop="edit(diyIndex)">
                      编辑
                    </a-button>
                    <a-button type="link" @click.stop="delDiyComment(diyIndex)">
                      删除
                    </a-button>
                  </div>
                </div>
              </li>
            </ul>

            <a-collapse v-model="activeKey">
              <a-collapse-panel key="1" :show-arrow="false">
                <div slot="header" class="collapse-title">
                  <span>模版评语 ｜ {{ subjectName }}</span>
                  <a slot="extra" class="action-btn">
                    <SvgIcon v-if="activeKey.length > 0" icon="fold" class="fold-icon" />
                    <SvgIcon v-else icon="develop" class="develop-icon" />
                    {{ activeKey.length > 0 ? "折叠" : "展开" }}
                  </a>
                </div>
                <ul class="fast-comment">
                  <li
                    class="fast-comment-item"
                    v-for="(subjectComment, i) in subjectComments"
                    @click="selectedSubjectComment(i)"
                    :key="subjectComment.id"
                  >
                    <a-tooltip
                      placement="top"
                      :get-popup-container="getPopupContainer"
                      :overlay-style="{width: '240px'}"
                      v-if="getBool(subjectComment.name)"
                    >
                      <template slot="title">
                        {{ subjectComment.name }}
                      </template>
                      <div class="text">
                        <p>{{ subjectComment.name }}</p>
                      </div>
                    </a-tooltip>
                    <div class="text" v-else>
                      <p>{{ subjectComment.name }}</p>
                    </div>
                  </li>
                </ul>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-spin>
    </div>
    <a-col
      :span="8"
      class="strong"
    >
      总评语
    </a-col>
    <a-col :span="24">
      <div class="textarea-title" @click.stop="togglePopover">
        <SvgIcon icon="talkMsg" class="talk-msg-icon" />
        快捷评语
      </div>
      <div class="textarea-wrap">
        <a-textarea
          ref="Textarea"
          @focus="textareaFocus"
          @blur="textareaBlur"
          class="textarea"
          placeholder="请输入评语"
          :rows="4"
          :max-length="maxRemarkLength"
          v-model="remark"
        />
        <p class="count">
          {{ countLength }}/{{ maxRemarkLength }}
        </p>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import { throttle } from 'lodash'
import correctLogger from '@/utils/logger/correct.js'

export default {
  name: 'FastComment',

  props: {
    linkTypeName: String
  },

  components: {
    SvgIcon
  },

  data() {
    return {
      remark: '',
      maxRemarkLength: 200,
      visible: false,
      spinning: false,
      activeKey: [1],
      subjectName: '',
      diyComments: [], // 自定义评语
      subjectComments: [], // 快捷模版评语
      setVisible: () => {
        this.visible = false
      }
    }
  },

  computed: {
    countLength() {
      return this.remark.length
    }
  },

  watch: {
    remark(v) {
      this.$emit('setRemark', v)
    },
    visible(v) {
      if (!v) {
        // 移除点击事件监听
        document.removeEventListener('click', this.setVisible, false)
      }
    }
  },

  mounted() {

  },
  methods: {
    diyTextareaChange(i) {
      // 获取文本宽度，是否展示tooltip
      const app = document.querySelector('#app')
      const span = document.createElement('span')
      span.innerHTML = this.diyComments[i].name
      app.appendChild(span)
      const showNum = span.offsetWidth > 342
      app.removeChild(span)
      this.diyComments[i].showNum = showNum
    },
    getPopupContainer() {
      return document.getElementById('popover-card')
    },
    delDiyComment(i) {
      const id = this.diyComments[i].id
      this.$confirm({
        content: '您确认删除此条评语吗？',
        centered: true,
        getContainer: () => document.getElementById('popover-card'),
        onOk: () => {
          // type 1:删除  2:计数
          this.$service.correction.delComment({ type: 1, id }).then(() => {
            this.diyComments.splice(i, 1)
            this.$message.success('删除成功')
          }).catch(() => {
            this.$message.error('删除失败，请重试')
          })
        }
      })
    },
    togglePopover() {
      this.diyComments = []
      this.subjectComments = []
      this.visible = !this.visible
      if (!this.visible) return
      this.spinning = true
      const { classTypeId, groupId, lessonId, aiLessonId, userId } = this.$route.query
      this.visible = true
      this.$service.correction.getComment({ classTypeId }).then(res => {
        const { customList, defaultList, subjectName } = res
        this.diyComments = customList.map(k => ({
          ...k,
          edit: false, // 控制按钮状态
          name: k.commentDesc, // 用于双向绑定可修改的数据
          sourceName: k.commentDesc, // 源数据保存，处理取消时回显
          showNum: false // 控制字符长度是否展示，超过一行再展示
        }))
        this.subjectComments = defaultList.map(k => ({
          ...k,
          name: k.commentDesc
        }))
        this.subjectName = subjectName
      }).finally(() => {
        this.spinning = false
      })
      this.$nextTick(() => {
        const popover = document.getElementById('popover-card')
        document.addEventListener('click', this.setVisible)
        popover.addEventListener('click', event => {
          event.stopPropagation()// 阻止冒泡
        })
      })
      // 快捷评语埋点
      correctLogger.fastComment({
        studentId: userId,
        groupId,
        lessonId,
        aiLessonId,
        courseId: classTypeId,
        linkType: this.linkTypeName
      })
    },
    getBool(msg, type) {
      if (type === 'diy') {
        // 获取文本宽度，是否展示tooltip
        const app = document.querySelector('#app')
        const span = document.createElement('span')
        span.innerHTML = msg
        // 加样式计算宽度更精确
        span.style.fontFamily = 'Microsoft YaHei UI'
        span.style.fontSize = '14px'
        span.style.letterSpacing = '0.04em'
        app.appendChild(span)
        const bool = span.offsetWidth > 367
        app.removeChild(span)
        return bool
      }
      // 获取文本宽度，是否展示tooltip
      const app = document.querySelector('#app')
      const span = document.createElement('span')
      span.innerHTML = msg
      // 加样式计算宽度更精确
      span.style.fontFamily = 'Microsoft YaHei UI'
      span.style.fontSize = '14px'
      span.style.letterSpacing = '0.04em'
      app.appendChild(span)
      const bool = span.offsetWidth > 495
      app.removeChild(span)
      return bool
    },
    save: throttle(async function(i) {
      const commentId = this.diyComments[i].id
      if (!commentId) {
        // 新增
        const { classTypeId } = this.$route.query
        const { name } = this.diyComments[i]
        this.$service.correction.addComment({ classTypeId, commentDesc: name }).then(id => {
          this.$message.success('创建成功')
          this.diyComments[i].id = id
          this.diyComments[i].sourceName = name
          this.diyComments[i].edit = false
        })
      } else {
        // 编辑
        const { name } = this.diyComments[i]
        this.$service.correction.updComment({ id: commentId, commentDesc: name }).then(id => {
          this.$message.success('编辑成功')
          this.diyComments[i].edit = false
        }).catch(() => {
          this.$message.error('编辑失败，请重试')
        })
      }
    }, 1 * 1000, { trailing: false }),
    selectedDiyComment(i) {
      const { edit, name, id } = this.diyComments[i]
      if (edit) return false
      this.remark = name
      this.visible = false
      // 调用计数接口（只要选择就调用，后端记数）, type: 2-计数
      this.$service.correction.delComment({ type: 2, id })
    },
    selectedSubjectComment(i) {
      const { name, id } = this.subjectComments[i]
      this.remark = name
      this.visible = false
      // 调用计数接口（只要选择就调用，后端记数）, type: 2-计数
      this.$service.correction.delComment({ type: 2, id })
    },
    cancelDiyComment(i) {
      const { id } = this.diyComments[i]
      if (!id) { // 未入库前端删除
        this.diyComments.splice(i, 1)
      } else {
        // 根据id获取此条评语信息并展示
        this.diyComments[i].name = this.diyComments[i].sourceName
        this.diyComments[i].edit = false
      }
    },
    edit(i) {
      this.diyComments[i].edit = true
    },
    addDiyComment() {
      this.diyComments.unshift({
        name: '',
        edit: true
      })
    },
    textareaFocus() {
      const dom = document.getElementsByClassName('textarea-wrap')
      dom[0].setAttribute('class', 'textarea-wrap textarea-wrap-focus')
    },
    textareaBlur() {
      const dom = document.getElementsByClassName('textarea-wrap')
      console.log(dom)
      dom[0].setAttribute('class', 'textarea-wrap')
    }
  }
}
</script>

<style scoped lang="less">
.fast-comment-txarea {
    margin-bottom: 20px;
    .popover-card {
        z-index: 199;
        height: auto;
        position: absolute;
        left: -563px;
        top: -1px;
        padding: 24px 0;
        background: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0px 2px 8px rgba(40, 41, 61, 0.04), 0px 16px 24px rgba(96, 97, 112, 0.16);
        .pointer {
            width: 100px;
            height: 100px;
            position: absolute;
            right: -11px;
            top: 49px;
            width: 0;
            height: 0;
            border-top: 15px solid transparent;
            border-left: 15px solid #fff;
            border-bottom: 15px solid transparent;
        }
        .fast-tooltip-wrap {
            width: 566px;
            .ant-collapse {
                border-top: 1px solid #ecedf0;
                border-left: 1px solid #ecedf0;
                border-right: 1px solid #ecedf0;
                .ant-collapse-item {
                    border-bottom: 1px solid #ecedf0;
                }
            }
            :deep(.ant-collapse-content) {
                border-top: 1px solid #ecedf0 !important;
                .ant-collapse-content-box {
                    padding: 0;
                }
            }
            :deep(.ant-collapse-header){
                background: #F5F7F9;
                height: 40px;
            }
            .collapse-title {
                height: 16px;
                line-height: 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: 'Microsoft YaHei UI';
                font-style: normal;
                font-weight: 700;
                font-size: 14px;
                letter-spacing: 0.06em;
                color: #505873;
                .action-btn {
                  font-family: 'Microsoft YaHei UI';
                  font-size: 14px;
                  font-weight: 400;
                  letter-spacing: 0.04em;
                  color: #3262FD;
                }
                .fold-icon, .develop-icon {
                  font-size: 16px;
                  fill:#3262FD;
                  position: relative;
                  top: 3px;
                }
            }
            .title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-left: 24px;
                padding-right: 32px;
                .num {
                    font-family: 'Microsoft YaHei UI';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    letter-spacing: 0.04em;
                    color: #98A2B2;
                }
            }
            .comment-wrap {
                width: 100%;
                max-height: 65vh;
                padding: 0 24px;
                overflow-y: scroll;
                &::-webkit-scrollbar{
                  width: 4px;
                }
                &::-webkit-scrollbar-thumb{
                    width: 4px;
                    height: 4px;
                    opacity: 0.8;
                    border-radius: 3px;
                    background: #98A2B2;
                }
                &::-webkit-scrollbar-track {
                    background: transparent;
                }
                &::-webkit-scrollbar-button {
                    background: transparent;
                }
                &::-webkit-scrollbar-corner {
                    background: transparent;
                }
                .diy-comment {
                    margin-bottom: 20px;
                    .item-comment {
                        padding: 8px;
                        box-shadow: inset 0px -1px 0px #EBEDF0;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        &:hover {
                            background: #F5F7F9;
                            cursor: pointer;
                        }
                        .str {
                            width: calc(100% - 130px);
                            .item-comment-textarea-wrap {
                              position: relative;
                              .item-textarea {
                                border-radius: 6px;
                                line-height: 22px;
                              }
                              .item-textarea-num {
                                  position: absolute;
                                  right: 14px;
                                  bottom: 6px;
                                  color: #98a2b2;
                                  font-size: 12px;
                              }
                            }
                            p {
                                width: 100%;
                                font-family: 'Microsoft YaHei UI';
                                font-style: normal;
                                font-weight: 400;
                                font-size: 14px;
                                letter-spacing: 0.04em;
                                color: #505873;
                                white-space: nowrap;
                                overflow:hidden;
                                text-overflow:ellipsis;
                            }
                        }
                    }
                }
                .fast-comment {
                    margin-bottom: 0;
                    .fast-comment-item {
                        height: 40px;
                        line-height: 40px;
                        width: 100%;
                        padding: 0 8px;
                        font-family: 'Microsoft YaHei UI';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        letter-spacing: 0.04em;
                        color: #303858;
                        &:not(:last-child) {
                            box-shadow: inset 0px -1px 0px #EBEDF0;
                        }
                        &:hover {
                            background: #F5F7F9;
                            cursor: pointer;
                        }
                        .text {
                            width: 100%;
                            p {
                                width: 100%;
                                white-space: nowrap;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                color: #505873
                            }
                        }
                    }
                }
            }
        }
    }
    .strong {
        font-weight: bold;
    }
    .textarea-title {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border-left: 1px solid #EBEDF0;
        border-right: 1px solid #EBEDF0;
        border-top: 1px solid #EBEDF0;
        margin-top: 5px;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        font-family: 'Microsoft YaHei UI';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        letter-spacing: 0.04em;
        color: #505873;
        .talk-msg-icon {
          font-size: 16px;
          fill:#505873;
          position: relative;
          top: 3px;
        }
        &:hover {
            cursor: pointer;
            color: #3262FD;
            .talk-msg-icon {
              font-size: 16px;
              fill:#3262FD;
            }
        }
        &:active {
            color: #505873;
            .talk-msg-icon {
              font-size: 16px;
              fill:#505873;
            }
        }
    }
    .textarea-wrap {
      border: 1px solid #EBEDF0;
      width: 100%;
      height: auto;
      padding: 6px 12px 24px 12px;
      resize: none;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      // &:after {
      //   position: absolute;
      //   content: "";
      //   display: block;
      //   width: 10px;
      //   height: 10px;
      //   background: #f00;
      //   bottom: 0;
      //   right: 0;
      //   border-radius: 2px;
      //   transform: translateY(-50%);
      // }
      .textarea {
          border-radius: 0;
          padding: 0 !important;
          border-color: transparent;
          height: 104px;
          resize: none;
          &:focus {
            box-shadow: none;
          }
      }
      .count {
          position: absolute;
          right: 14px;
          bottom: 6px;
          color: #98a2b2;
          font-size: 12px;
      }
    }
    .textarea-wrap-focus {
      border: 1px solid transparent;
      box-shadow:  0 0 0 1px #5c87ff,0 0 0 3px #DBE2FF;
      transition: all 0.3s, height 0s;
    }
}
</style>
